export default {
  address: {
    name: 'Address',
    city: 'City',
    country: 'Country',
    edit: 'Edit address',
    postalCode: 'ZIP Code',
    street: 'Street and house number',
    street2: 'Add',
  },
  basePlan: {
    aheadOfTime: 'Ends {amount} earlier than planned',
    aheadOfTimeFixed: '{amount} earlier than in the base plan',
    aheadOfTimeReached: 'Will be completed {amount} earlier than planned',
    basePlanDateText: 'Comparison with plan as of {date}',
    behindOnTime: 'Ends {amount} later than planned',
    behindOnTimeFixed: '{amount} later than in the base plan',
    behindOnTimeReached: 'Will be completed {amount} later than planned',
    finishesOnTime: 'Ends exactly as planned',
    finishesOnTimeFixed: 'Same date as in the base plan',
    finishesOnTimeReached: 'Will be completed exactly as planned',
    legendBeforeTime: 'Ends earlier than planned',
    legendBehindTime: 'Ends later than planned',
    legendOnTime: 'Ends exactly as planned',
    legendSubText: 'The planned end date is compared with the current end date',
    legendUnavailable: 'Comparison not possible',
    setBasePlanTitle: 'Set base plan',
    setBasePlanDescription:
      'Set the current or an older status as the new base plan for the planned-actual comparison. All base values are reset by this.',
    setBasePlanButton: 'Set as base plan',
    setBasePlanNow: 'Set now',
    selectAVersion: 'Select a project version',
    newBasePlanName: 'Base plan from {date}',
    newBasePlanNotificationTitle: 'Base plan successfully set',
    newBasePlanNotificationBody:
      'Your version <strong>{name}</strong> has been set as the base plan. If necessary, set a different plan as the base plan via <strong><span class="material-icons" style="font-size: 14px; height: 14px; width: 14px; position: relative; top: 2px">more_vert</span> More </strong> or via <strong><span class="material-icons" style="font-size: 14px; height: 14px; width: 14px; position:relative; top: 2px">filter_list</span> Filter & View </strong>.',
    useAnotherVersion: 'Use another version',
    noBasePlanSet: 'No base plan set',
    compareWith: 'Compare with schedule from {date}',
  },
  color: {
    define: 'Define own color',
    error: 'Please enter a valid hex-code',
    hexcode: 'Enter Hex-code',
    select: 'Choose a color',
    title: 'Color',
  },
  communication: {
    address: 'Address',
    email: 'E-mail',
    telephoneNumber: 'Phone',
    landlineNumber: 'Landline',
    mobileNumber: 'Mobile',
    placeOfExecution: 'Place of execution',
  },
  dashboard: {
    projectReasonsTitle: 'Disruption/delay reasons',
    projectReasonsSubtitle: 'Within the project (activities of last 4 weeks)',
    projectReasonsDelay: 'Delay',
    projectReasonsDisruption: 'Disruption',
    projectReasonsDisruptionOrders: 'Activity disrupted | Activities disrupted',
    projectReasonsDelayOrders: 'Activity delayed | Activities delayed',
    projectProgressActual: 'Actual: {value}%',
    projectProgressExpected: 'Expected: {value}%',
    projectProgressNoOrders: 'No activities created yet',
    projectProgressTitle: 'Progress',
    projectProgressWhole: 'Total',
    projectProgressTooltip:
      'Progress visualizes what percentage of all activities within the project are in the past, compared to the percentage of activities that should be in the past. Data basis are the end dates of the activities.',
    projectProgressTooltipContributor:
      'Progress visualizes what percentage of all activities of this company within the project are in the past, compared to the percentage of activities that should be in the past. Data basis are the end dates of the activities.',
    milestonesTitle: 'Open milestones',
    milestonesNoMilestones: 'No milestones configured',
    milestonesNoMilestonesBody: 'Create milestones in the schedule to view them here.',
    milestonesReached: '{count}/{total} reached',
    milestonesAllMilestonesReached: 'All milestones reached',
    milestonesTableDate: 'Date',
    milestonesTableType: 'Type',
    milestonesTableBasePlan: 'Base plan',
    milestonesTableAssignment: 'Assignment',
    milestonesTableTooltip: 'Open schedule',
    milestonesScheduleViewLink: 'To Milestone view',
    tradesReasonsTitle: 'Disruption/delay reasons',
    tradesReasonsSubtitle: 'Within all trades (activities of last 4 weeks)',
    tradesReasonsDelay: 'Delay',
    tradesReasonsDisruption: 'Disruption',
    tradesReasonsEmpty: 'No data available',
    tradesReasonsYAxisTitle: 'Number of activities',
    eventsOfWeekCard: {
      title: 'Activities of this week',
      subtitle: 'Evaluation of the status reports',
      chartSubtitle: 'Activity | Activities',
      totalOrders: '({count} total)',
    },
  },
  dependents: {
    dryingTimeOf: 'Drying time of "{name}"',
    milestoneFollowingDryingTime: 'Milestone following "{name}"',
    followingDryingTime: 'Following "{name}"',
  },
  dryingBreak: {
    add: 'Add drying time',
    defaultName: 'Drying Time',
    duration: 'Duration',
    name: 'Name',
  },
  duration: {
    day: 'd',
    dayLong: 'day | days',
    hour: 'h',
    hourLong: 'hour | hours',
    hourlyHint: '1 day equals {hours} hours',
    minute: 'm',
    minuteLong: 'min',
    second: 's',
    secondLong: 'sec',
    sign: {
      positive: 'Positive',
      negative: 'Negative',
    },
    title: 'Duration',
  },
  file: {
    showMore: 'Show more',
    noPreview: 'No preview of the file can be displayed.',
    openInBrowser: 'Open file in browser',
    size: {
      max: 'max.',
      exceeded: 'The maximum file size is {size}',
      kB: 'KB',
      mB: 'MB',
    },
    title: 'File',
    uploadDialog: {
      clickHintUpload: 'Click to upload',
      clickHintImport: 'Click to import',
      dragHint: 'or drag & drop',
      error: {
        maxSizeExceeded: 'The file is too big, please remove it.',
        unsupportesFiles: 'Files of type {types} cannot be uploaded.',
      },
    },
  },
  flexibleTradeSequence: {
    createCancelHeader: 'Dismiss sequence',
    defaultCalendarUsedHint:
      'Note: All work packages have been assigned the standard working hours.',

    dependencyCycleTitle: 'Cyclic dependency detected',
    dependencyCycleText:
      'Updating the sequences in your schedule would lead to recursive dependencies between activities. \n You can update the sequence yourself, but this and all future changes can not be transferred to the sequences in your schedule.',
    dependencyCycleConfirm: 'Update anyway',

    editCancelHeader: 'Dismiss changes',
    editorCopyLabel: 'Copy template into project',
    editorDeleteLabel: 'Delete sequence',
    editorSaveLabel: 'Create now',
    editorSaveErrorText:
      'To be able to save a sequence, the sequence name must be set uniquely and at least one work package including a trade is required.',
    editorSaveErrorTitle: 'Minimum requirements not met',
    editorUpdateLabel: 'Update sequence',
    editorUpdateErrorText:
      'There have been no changes to this sequence. Modify activities, dependencies or general data to update.',
    editorUpdateErrorTitle: 'No changes',
    editorUpdateExistingNameErrorText:
      'Sequence name already exists. Please choose a different name.',
    editorUpdateExistingNameErrorTitle: 'Name already exists',

    export: {
      asPdf: 'Export as PDF',
      exportingTemplateTitle: 'Exporting template',
      exportingSequenceTitle: 'Exporting sequence',
      exportHeaderSequenceWithPagesPlaceholder: 'Version from {0} - Sequence - %PAGES%',
      exportHeaderTaskList: 'Version from {0} - Content - Page {1} of {2}',
    },

    headerCreateTitle: 'Create sequence',
    headerCreateTemplateTitle: 'Create sequence template',
    headerEditTitle: 'Edit sequence',
    headerHelpText: 'How do I use the editor',
    headerInputDefaultLength: 'Default length of work package',
    headerInputName: 'Name of sequence',
    headerTemplateTitle: 'Sequence template',
    headerTemplateHelpText: 'What is a sequence template',

    sequenceDetailsHeading: 'Sequence details',
    sequenceDetailsTradesInUse: 'Trades in use',
    sequenceDetailsSearchTrade: 'Search trade',

    tradesListHeading: 'Work packages',
    tradesListDescription:
      'Drag the trade directly into the plan on the left and edit the details of the work package then.',
    tradesListSearchPlaceholder: 'Search trade',
    tradesListLabel: 'Existing trades',
    tradesListEmpty: 'No existing trades found',

    workPackageDetailsAddTask: 'Add task',
    workPackageDetailsDependencyTab: 'Dependencies',
    workPackageDetailsDependencyMissing: 'No existing dependencies',
    workPackageDetailsName: 'Name',
    workPackageDetailsNoTasks: 'No existing tasks',
    workPackageDetailsTaskPlaceholder: 'Enter task',
    workPackageDetailsTasks: 'Tasks',
    workPackageDetailsTrade: 'Trade',

    myTradeSequencesTab: 'Sequences',
    templatesTab: 'Templates',
    searchSequence: 'Search sequence',
    tradeSequenceTemplateListEmpty: 'No sequence templates created',
    tradeSequenceTemplateListEmptyDetails:
      'Your company can create company-wide sequences here, which you can then use for your project.',
    tradeSequenceTemplateListEmptyDetailsAdmin:
      'You can create a sequence template in the templates tab and use it across your organization in any project.',
    tradeSequenceTemplateListCTA: 'To the global templates',
    turnIntoTemplate: 'Create global template',
    turnIntoTemplateTooltip: 'Action not possible',
    turnIntoTemplateTooltipText1:
      'Cannot create template because it contains the trade {trade} which is a project trade. This has to be replaced first in order to perform this action.',
    turnIntoTemplateTooltipText2:
      'Cannot create template because it contains the trades {trades} and {last} which are project trades. they have to be replaced first in order to perform this action.',
    turnIntoTemplatePopupDetails:
      'You use this project sequence to create a global template that can be used outside of this project.\n\n' +
      'The working times are not taken into account during the creation.',
    turnIntoTradeSequenceTooltip: 'Copy into project',
    turnIntoTradeSequencePopupTitle: 'Create project sequence',
    turnIntoTradeSequencePopupDetails:
      'For your project you will create a copy of the sequence template {templateName}.',
    turnIntoTemplateNotificationTitle: 'Global template created',
    turnIntoTemplateNotificationBody:
      'Your sequence has been successfully saved as a global template and can now be seen and used by your team in any project.',
    turnIntoTemplateNotificationAction: 'Show template',
    tradeSequenceDeletedTitle: 'Sequence could not be updated',
    tradeSequenceDeletedText: 'The sequence you are trying to update could not be found',
  },
  gallery: {
    close: 'Close gallery',
    next: 'Next',
    prev: 'Previous',
    uploadedBy: 'Uploaded: {name}',
  },
  leanProject: {
    testProject: 'Test project',
    testProjectDescription: "Test koppla's features with no obligation and no costs.",
    realProject: 'Real project',
    realProjectDescription: 'Prepare a real project of your company.',
    projectConversionDescription:
      'Test projects can be converted into real projects at any time. Real projects can be initially prepared and activated later.',
    inputName: 'Project name',
    inputNumber: 'Project number',
    activated: {
      openScheduleHint: 'The project is active. It can only be edited in the schedule.',
      openSchedule: 'Open schedule',
    },
    beginAt: 'Project start',
    viewProject: 'View project (in read-only)',
    notifications: {
      deleted: {
        title: 'Project deleted',
        description: 'The project has been deleted.',
      },
      archived: {
        title: 'Project archived',
        description: 'You will be able to find this project in the <b>"Archive"</b> tab.',
      },
      unarchived: {
        title: 'Project unarchived',
        description: 'You will be able to find this project in the <b>"{tab}"</b> tab.',
      },
      statusUpdated: {
        title: 'Project status updated',
        description:
          'The status of your project <b>{projectName}</b> has been changed to <b>{projectStatus}</b>.',
      },
      detailsUpdated: {
        title: 'Project details updated',
        description: 'Your changes have been saved.',
      },
      turnedIntoRealProject: {
        title: 'Project turned into a real project',
        description: 'You will be able to find this project in the <b>"Real Projects"</b> tab.',
      },
    },
    archive: {
      action: 'Archive project',
      description:
        'Do you want to move this project to the archive? Archived projects can be unarchived any time.',
      confirm: 'Yes, archive',
    },
    unarchive: {
      action: 'Unarchive project',
      description: 'Do you want to unarchive this project and move it back to the real projects?',
      confirm: 'Yes, unarchive',
    },
    calendar: {
      allTitle: 'Work schedules',
      create: 'Create work schedule',
      calendarUpdateNotificationTitle: 'Work schedule updated',
      calendarUpdateNotificationBody:
        'The work schedule has been updated. All activities that use this work schedule have been adjusted to the new working hours.',
      defaultHint: {
        hide: 'Do not show again',
        subtitle:
          'Activities created from now on will have this work schedule pre-selected as the default work schedule. You can choose a different work schedule for your activities at any time.',
        title: 'Set new default work schedule',
      },
      defaultTitle: 'Standard',
      delete: {
        buttonText: 'Delete work schedule',
        done: 'Work schedule deleted',
        inUse: 'Work schedule cannot be deleted because it is in use',
        isDefault: 'The default work schedule cannot be deleted',
        last: "Work schedule can't be deleted, because a work schedule must always exist",
        message: 'Do you want to delete the selected work schedule? ',
      },
      edit: 'Update work schedule',
      empty: 'No work schedule created yet',
      name: 'Name',
      saveWarning: {
        subtitle:
          'You want to update the work schedule. If you confirm, all activities that use this work schedule will be adjusted to the new working hours. Are you sure?',
        title: 'Update work schedule',
        yes: 'Yes, I am sure',
      },
      selectAsDefault: 'Set as default work schedule',
      title: 'Work schedule',
      unselectDefault:
        'This work schedule is set as default. Open a different work schedule to change this selection.',
      why: {
        reason:
          'You can create different work schedules, if single activities or groups of activities have different working times (e.g. working saturdays).',
        title: 'Why can I create different work schedules?',
      },
      workingTime: {
        add: 'Add period',
        copy: 'Copy entries for all days',
        end: 'End',
        remove: 'Remove period',
        start: 'Start',
        title: 'Working time',
        until: 'to',
      },
    },
    cycleTime: {
      schedule: {
        parallel: 'The trades run in parallel',
        serial: 'The trades run consecutively',
      },
      title: 'Cycle time',
    },
    delete: {
      dialog: {
        title: 'Delete this project irreversibly?',
        description: 'This action is irreversible and can not be undone.',
        confirmation: 'Enter the text {DELETE} in the field below to confirm this action.',
        inputLabel: 'Confirm Deletion*',
        inputPlaceholder: 'Text',
        confirmButton: 'Irreversibly delete project',
      },
      action: 'Delete project',
    },
    endAt: 'Project end date',
    finishTime: 'Expected completion date',
    floor: {
      add: 'Add floor',
      abbreviation: '{n}. F',
      basement: 'B',
      basementWithCount: 'B{n}',
      groundFloor: 'G',
      remove: 'Remove floor',
      status: {
        done: 'Completed',
        inactive: 'Not started',
      },
      title: 'Floor | Floors',
      withoutGroundFloor: 'Floors (excluding G)',
    },
    location: {
      title: 'Location',
    },
    generalSettings: {
      title: 'General settings',
      durationOfDay: {
        label: 'Duration of a working day in hours',
        title: 'How many hours does your working day have?',
      },
    },
    holiday: 'Holiday',
    membership: {
      add: 'Add team member',
      contactPerson: 'Site Management',
      delete: {
        buttonText: 'Remove team member',
        message:
          'Do you want to remove the selected team member from the project?\n\nThis action cannot be undone.',
        success: 'Team member successfully removed',
      },
      empty: 'No team member added',
      new: 'New team member',
      notFound: 'Team member not found',
      permissions: {
        reporter: 'Can create status reports and edit tickets.',
        editor: 'Can read, edit and create schedule and issues and add project participants.',
        viewer: 'Able to read schedule and issues.',
      },
      role: 'Role',
      roles: {
        admin: 'Administrator',
        employee: 'Employee',
      },
      roleDescriptions: {
        admin: 'Can manage company settings and view and manage all projects.',
        employee: 'Can create and manage own projects and be added to projects.',
      },
      select: 'Select team member',
    },
    milestones: {
      acceptanceCriteriaAdd: 'Add acceptance criterion',
      acceptanceCriteriaEmpty: 'No acceptance criteria added',
      acceptanceCriteriaPlaceholder: 'Enter acceptance criterion',
      add: 'Add milestone',
      addedInSchedule: 'Milestone added',
      assignment: {
        title: 'Assignment (optional)',
        tradeDescription: 'Trade',
        optionalTradeDescription: 'Trade (overrides the colour choice above)',
      },
      colorHint: 'Got overwritten by the trade assignment',
      deleteCompletedTooltip: 'Milestone cannot be deleted as it has already been achieved',
      deleted: 'Milestone removed',
      disabledTooltip: 'A trade must be assigned for teams and companies',
      editCompletedTooltip: 'Milestone cannot be edited as it has already been achieved',
      editedInSchedule: 'Milestone updated',
      fixed: 'Fixed',
      fixedTooltip: 'You will be notified as soon as \nthe milestone is at risk',
      flexible: 'Flexible',
      flexibleTooltip: 'The milestone moves with \ndependent orders',
      name: 'Name',
      new: 'New milestone',
      nextUpcoming: 'Next milestone',
      start: 'Start',
      status: {
        achievedAtBy: 'Milestone has been reported as achieved on {date} by {userName}',
        disabled:
          'All acceptance criteria have to be fulfilled before you can report the milestone as achieved.',
        notAchieved: 'Milestone has not been achieved yet',
        reportAsAchieved: 'Report as achieved',
        reportAsOpen: 'Report as open',
        title: 'Current status',
      },
      tabs: {
        details: 'General',
        dependencies: 'Dependencies',
      },
      title: 'Milestone | Milestones',
    },
    onboarding: {
      exitConfirmationTitle: 'Exit project',
      exitConfirmationMessage:
        'Do you want to pause the setup of your project? You can choose the structure at a later time.',
      exitConfirmationAction: 'Exit now',
      selectTemplateType: {
        subtitle: 'Select your starting file structure to begin your next project in a few clicks',
        structureTitle: 'Blank',
        structureSubtitle:
          'Start with a blank slate and add your own content to a standard template.',
        structureContentTitle: 'Pre-filled',
        structureContentSubtitle: 'Hit the ground running using a template with example content.',
        importTitle: 'Import',
        importSubtitle:
          'Start in full stride by importing an existing mpp project file (max. 40 MB).',
      },
    },
    orders: {
      wbsSectionAssignment: 'Assignment',
      calendar: {
        title: 'Working hours',
        information:
          'You have defined several working hours. Currently the working time for the calendar {selectedCalendar} is selected.',
      },
      contextmenu: {
        copy: 'Copy | Copy | Copy ({n})',
        createTradeSequenceFromOrders: 'Create a sequence',
        cut: 'Cut | Cut | Cut ({n})',
        delete: 'Delete | Delete | Delete ({n})',
        deleteDependencies: 'Delete dependencies | Delete dependencies | Delete dependencies ({n})',
        paste: 'Paste | Paste | Paste ({n})',
        edit: 'Edit | Edit | Edit({n})',
        reportStatus: 'Report status | Report status | Report status ({n})',
      },
      tabs: {
        dependencies: 'Dependencies',
        details: 'Details',
        files: 'Files',
        photos: 'Photos',
      },
      copy: 'Activity copied to clipboard | {n} activities copied to clipboard',
      create: {
        new: 'New activity',
        title: 'Add activity',
        fullDay: 'All day',
        hint: {
          createTitle: 'Activity added',
          editTitle: 'Activity updated',
        },
      },
      cut: 'Activity cut | {n} Activities cut',
      delete: {
        completedTooltip: 'Activity cannot be deleted as it has already been completed',
        permissionTooltip:
          "Activity cannot be deleted because the trade isn't assigned to your team/company",
      },
      deleted: 'Activity removed | {n} activities removed',
      edit: {
        permissionTooltip:
          "Activity cannot be edited because the trade isn't assigned to your team/company",
        completedTooltip: 'Activity cannot be edited as it has already been completed',
        disableWarning: 'This activity is part of a sequence and cannot be edited.',
      },
      multiEdit: {
        title: 'You are editing {count} activities',
        nameFieldPlaceholder: "Activities' name",
        timeInputDisableInfo:
          'Period and Duration can be edited if the same working hours are selected.',
      },
      editStatus: {
        confirmDone: 'Check finished message',
        title: 'Report new status',
      },
      end: 'To',
      errors: {
        endBeforeStart: 'The end date must not be before or equal the start date',
        outsideWorkingTimes: 'Out of working hours',
      },
      fixError: 'Fix error',
      fixTimes: {
        hint: 'Activity locked. The times cannot be changed.',
        subtitle:
          'The times of a locked activity can neither be changed manually nor automatically in the schedule. They only remain editable via the sidebar.',
        title: 'Lock activity | Lock activities',
      },
      headings: {
        timetable: 'Period',
        assignment: 'Assignment',
      },
      internalId: 'Activity number',
      paste: 'Activity inserted | {n} Activities inserted',
      progress: {
        at: 'Progress: {n}%',
        atDescription: 'Progress in %',
        title: 'Activity progress: {n}%',
        slider: '1. How far are you?',
        moveSlider: 'Move the slider to start',
        option: '2. Choose an option',
        reason: '3. Choose a cause',
        comment: {
          label: 'Share further information',
          placeholder: 'Enter a description...',
          hint: 'Description is required',
        },
      },
      start: 'From',
      title: 'Activity | Activities',
      titleWithInternalId: 'Activity #{id}',
    },
    participants: {
      createSelectNow: 'Create and select now',
      inviteNow: 'Invite now',
      mail: 'Email',
      membership: {
        add: 'Add to project',
        addExisting: 'Employee already has access to koppla?',
        addNew: 'Employee not yet registered on koppla?',
        invitationInfo:
          'We will send an email to the invited employee at the email address provided to register on koppla within your company.',
        invitationSent: 'Invitation sent',
        inviteUser: 'Invite employee',
        members: ' Member | Members',
        name: 'Name',
        selectUser: 'Select employee',
      },
      selectNow: 'Select now',
      subcontractor: {
        add: 'Add contractor',
        addText: 'Select your contractor from the koppla database or create a new company.',
        addTrades: 'For which trades does the company appear on the project?',
        contacts: {
          add: 'Add employee',
          addExisting: 'Existing employee in the company',
          addInstruction:
            'Add your collaborators to the project so they can see their activities in the app.',
          addNew: 'Invite employee',
          delete: 'Remove employee',
          deleteMessage:
            'Do you want to remove the selected employee {employee}? The employee can then no longer access the project.',
          defaultRole: 'Foreman',
          edit: {
            submit: 'Update now',
            title: 'Edit employees',
            worker: 'Employees',
          },
          empty: 'No collaborators selected.',
          role: 'Employee role',
          selectUser: 'Select employee',
          status: {
            active: 'Active',
            invited: 'Invited',
            noActives: 'No active employees yet',
            noInvited: 'No pending employee invitations',
          },
          title: 'My employees',
        },
        contactsTitle: 'Employee',
        create: 'Create new contractor {subcontractor}',
        emptyForTrade: 'There is no contractor with this trade.',
        error: {
          userExists:
            'The person cannot be invited because they already have a koppla account. You can only invite people without a koppla account.',
        },
        fittingTrade: 'Matching contractor',
        invitationInfo: 'We will send an email to the company to register on koppla.',
        inviteTenant: 'Invite contractor',
        name: 'Company name',
        noFittingHint:
          'No company has assigned the matching trade | No company has assigned the matching trades',
        nonFittingTrade: 'All my contractors',
        search: 'Search companies',
        empty: 'No companies found',
        status: {
          active: 'Active',
          inactive: 'Inactive',
          inactiveTooltip:
            'The contractor will only be notified and get access once you invite an employee from them.',
          title: 'Status',
        },
        title: 'Contractors',
      },
      title: 'Project participants',
    },
    pauses: {
      add: 'Add project break',
      addAfterActivation:
        'The project is already activated. The new break does not affect the existing activities.',
      addedInSchedule: 'Break added',
      deleted: 'Break removed',
      edit: 'Edit break',
      editedInSchedule: 'Break updated',
      empty: 'No project breaks added',
      end: 'End',
      name: 'Name',
      new: 'New break',
      nextUpcoming: 'Next project break',
      picker: {
        chooseStart: 'Select start',
        chooseEnd: 'Select end',
      },
      start: 'Start',
      title: 'Break',
    },
    planning: {
      holidayBanner:
        'To show you holidays, we need a project address. Click here to directly add an address.',
    },
    room: {
      add: 'Add room',
      remove: 'Remove room',
    },
    schedule: {
      mainSlot: 'Events',
      jumpToToday: 'Today',
      jumpToTodayTooltip: 'Jump to today',
    },
    status: {
      active: 'Active activity | Active activities',
      empty: 'Currently there are no active events',
      total: 'Total: {n}',
      dialog: {
        title: 'Change status',
        description: 'Change the status of your project here.',
      },
      tooltip: 'Change status',
    },
    statusReport: {
      comment: 'Comment',
      explanation: {
        delay: 'The work is delayed',
        done: 'The work is completely finished',
        error: 'The work is currently not possible',
        notSet: 'No current status has been reported yet',
        notStarted: 'The work has not been started yet',
        rejected: 'The completed report has been rejected by the general contractor',
        reportedDone: 'Reported completed by contractor',
        success: 'Everything is going according to plan',
      },
      history: {
        created: 'Activity created',
        empty: {
          title: 'No messages',
          subtitle: 'No status has been reported yet.',
        },
        newStatus: 'New status',
        return: 'Back to overview',
        title: 'Activity history',
        tooltip: 'Show history',
      },
      reason: {
        description: 'Cause: {reason}',
        material: 'Material missing',
        other: 'Other cause',
        preliminaryWork: 'Preliminary work missing',
        rework: 'Rework',
        title: 'Cause',
        staff: 'Personnel missing',
      },
      status: {
        delay: 'Delay',
        done: 'Completed',
        error: 'Disruption',
        notSet: 'No status',
        rejected: 'Rejected',
        reportedDone: 'Reported completed',
        success: 'According to plan',
        title: 'Stand',
      },
    },
    title: 'project',
    trade: {
      add: 'Add trade',
      assign: 'Assign trade',
      color: {
        hint: 'This color helps you to better identify the trade.',
      },
      create: {
        alertTitle: 'Import from project',
        alertText:
          'To get started faster, you can optionally import all trades from an existing project and then adapt them.',
        hint: 'You create a trade that can be used and deployed across projects.',
        submit: 'Create now',
        title: 'Create new trade',
      },
      createForProject: {
        action: 'Create new project trade',
        hint: 'You create a project trade that can only be used and deployed in this project.',
        submit: 'Create now',
        title: 'Create project trade',
      },
      createFromSearch: 'Create {name} newly?',
      delete: {
        hint: 'Are you sure you want to delete the trade {trade}?\nThis action cannot be undone.',
        replace:
          "\nSince it is currently used in {projects} you'll need to replace it with an alternative trade.",
        submit: 'Delete now',
        title: 'Delete trade',
      },
      deleteForProject: {
        hint: 'Are you sure you want to delete the project trade {trade}?\nThis action cannot be undone.',
        replace:
          '\nSince it is currently used in the project, you need to replace it with an alternative trade.',
        submit: 'Delete now',
        title: 'Delete project trade',
      },
      edit: {
        hint: 'You are editing a trade that can be used and deployed across projects.',
        submit: 'Update',
        title: 'Edit trade',
      },
      editForProject: {
        hint: 'You are editing a project trade that can only be used and deployed in this project.',
        submit: 'Update',
        title: 'Edit trade',
      },
      emptyForSubcontractor: 'No trades have been assigned to this company.',
      fittingSubcontractor: 'Matching trades',
      importDialogTitle: 'Import trades',
      importDialogText:
        'Select a project from which you would like to import the trades. You can adjust the imported trades later.',
      importDialogSubmit: 'Import {n} trades',
      name: 'Name',
      nameIsTaken: 'This trade already exists',
      nameAbbreviation: 'Abbreviation',
      noGlobalTradesButton: 'Create trade',
      noGlobalTradesTitle: 'No company-wide trades exist',
      noGlobalTradesBody:
        'You can create standard trades and then use them company-wide in each of your projects.',
      nonFittingSubcontractor: 'All my trades',
      projectTrade: 'Project trade',
      select: 'Select trade',
      selectType: 'Select trade type',
      title: 'Trade | Trades',
    },
    tradeSequence: {
      add: 'Create sequence',
      allTitle: 'Sequences',
      createdAndInserted: 'Sequence created and inserted',
      delete: {
        button: 'Delete sequence',
        buttonText: 'Remove sequence',
        message: 'Do you want to delete the selected sequence?',
        success: 'Sequence successfully removed',
      },
      duplicate: {
        error: 'The selected trade already exists. You can use it in the trade selection.',
        title: 'Duplicate sequence',
      },
      alreadyExisting: 'There already exists a sequence with this name',
      edit: 'Edit sequence',
      empty: 'No sequence created yet',
      inserted: 'Sequence inserted',
      label: 'Name',
      loading: {
        trades: 'Trades are updating...',
        orders: 'Activities are updating...',
        dependencies: 'Dependencies are updating...',
      },
      manage: {
        add: 'Create new one',
        all: 'Manage all',
        paste: 'Insert sequence',
      },
      sequenceWithNumber: 'Sequence {n}',
      title: 'Project sequence | Project sequences',
    },
    tradeSequenceActivity: {
      add: 'Add cycle',
      delete: {
        title: 'Remove cycle',
        subtitle: 'The entire cycle and all added trades will be removed from the sequence.',
      },
      name: 'Cycle',
      nameInput: 'Name',
      nameIsTaken:
        'A work package with this name already exists. {name} {number} would be possible.',
      personnelCapacity: {
        count: 'Number',
        hint: 'By entering the personnel capacity, a target/actual comparison can be used and displayed in the schedule.',
        optional: 'Personnel capacity (optional)',
      },
      workpackage: {
        add: 'Add work package',
        delete: 'Remove work package',
        title: 'Work package',
      },
    },
    turnIntoRealProject: {
      dialog: {
        title: 'Convert test project to real project',
        description:
          'All your data will be retained. This project will be listed in the "Real Projects" section in the future.\n\nThis action cannot be undone.',
        learnMore: 'What distinguishes test projects?',
        confirmButton: 'Change now',
      },
      tooltip: 'Turn into real project',
    },
  },
  membership: {
    isAdmin: {
      title: 'Administrator',
      description: 'Can manage company settings and view all projects',
    },
    role: 'Role',
    title: 'Membership',
  },
  nonWorkingTimeResolution: {
    notificationTitle: 'Activity automatically moved | Activities automatically moved',
    notificationSubtitleStart:
      'An activity that would have started on a non-working day due to your changes has been automatically moved to the next working day. | Several activities that would have started on a non-working day due to your changes have been automatically moved to the next working day.',
    notificationSubtitleEnd:
      'An activity that would have ended on a non-working day due to your changes has been automatically moved to the previous working day. | Several activities that would have ended on a non-working day due to your changes have been automatically moved to the previous working day.',
    notificationAction: 'Add exception',
    dialogTitle: 'Add exception',
    dialogSubtitle: 'Add an exception to allow the shift you made.',
    dialogSingleOption:
      'Make {date} a working day for this activity. | Make {date} a working day for all affected activities.',
    dialogAllOption:
      'Make {date} a working day for the work schedule {calendars}. All activities with this work schedule will be updated. | Make {date} a working day for the work schedules {calendars}. All activities with these work schedules will be updated.',
    activityNotFoundNotificationTitle: 'Activity not found',
    activityNotFoundNotificationBody:
      'The activity you tried to add an exception to could not be found.',
  },
  order: {
    actions: {
      start: {
        title: 'Start activity',
        details:
          'Do you want to start the activity? The activity will be set to "In progress" status.',
        abort: 'Cancel',
        confirm: 'Start now',
      },
      stop: {
        title: 'Finish activity',
        details:
          'Do you want to finish the activity? The activity will be moved to the "Completed" status.',
        abort: 'Cancel',
        confirm: 'Finish now',
      },
    },
    contact: 'Contact',
    description: 'Description/Info',
    descriptionEmpty: 'No further info stored.',
    duration: {
      recorded: 'Total working time',
    },
    faulty: 'Free of defects',
    finishAt: 'Planned end',
    finishedAt: 'End',
    id: 'ID',
    internalId: 'Activity number',
    name: 'Name',
    originallyPlanned: '(Planned: {dateTime})',
    phoneNumber: 'Phone number',
    startAt: 'Planned start',
    startedAt: 'Start',
    statusNew: {
      empty: 'No activities',
      faulty: 'Poor',
      finished: 'Completed',
      inProgress: 'In progress',
      notPlanned: 'In planning',
      planned: 'Planned',
      title: 'Status',
    },
    timezone: 'Time zone',
    title: 'Activity',
  },
  orderContact: {
    create: 'Add contact',
    createFromCustomer: {
      submit: 'Take over now',
      title: 'Take over contact',
    },
    delete: {
      buttonText: 'Remove contact',
      message: 'The selected contact will be removed.',
      success: 'Contact successfully removed',
    },
    empty: 'No contacts',
    name: 'Name',
    newContact: 'New contact',
    role: {
      hint: "The role describes the contact's field of activity",
      title: 'Role',
    },
    title: 'Contact person',
  },
  orderDependency: {
    from: 'From',
    to: 'To',
    type: 'Type',
    typeNames: {
      startToStart: 'Start-Start (SS)',
      startToEnd: 'Start-Finish (SF)',
      endToStart: 'Finish-Start (FS)',
      endToEnd: 'Finish-Finish (FF)',
    },
    lagBufferInfo:
      'The minimal time distance describes the minimal distance that has to be between the connected events.',
    buffer: {
      title: 'Current buffer: {buffer}',
    },
    lag: {
      decrease: 'Decrease time interval',
      increase: 'Increase time interval',
      title: 'Minimum distance',
    },
    delete: {
      buttonText: 'Remove dependency',
      done: 'Dependency removed | {n} dependencies removed',
      message: 'The dependency between the selected activities is removed.',
      success: 'Dependency successfully removed',
    },
    typeLong: 'Type of dependency',
    title: 'Dependency',
    valid: 'Valid',
    invalid: 'Invalid',
    onlyAssigned: 'Assigned ones only',
  },
  link: {
    title: 'Link | Links',
    create: 'Add link',
    edit: 'Edit link',
    delete: {
      title: 'Remove link',
      confirmation: 'If you confirm, the link will be removed.',
    },
    empty: 'No links',
    urlInputLabel: 'URL',
    urlInputPlaceholder: 'www.url.de',
    titleInputLabel: 'Title (optional)',
    titleInputPlaceholder: 'Title',
    urlMalformedError: 'This URL does not seem to be valid. Please check it.',
    urlExistsError: 'This URL has already been added.',
  },
  document: {
    create: 'Add documents',
    delete: {
      buttonText: 'Remove document',
      message: 'If you confirm, the document will be removed.',
      success: 'Document successfully removed',
    },
    download: 'Download document',
    empty: 'No documents',
    hint: 'Maximum {n}',
    name: 'Name',
    selectMultiple: 'Select new documents',
    title: 'Document | Documents',
  },
  photo: {
    create: 'Add photos',
    delete: {
      buttonText: 'Remove photo',
      message: 'When you confirm the photo will be removed.',
      success: 'Photo successfully removed',
    },
    download: 'Download photo',
    empty: 'No photos',
    select: 'Select new photos',
    title: 'Photos',
    details: {
      title: 'Information',
      name: 'Name',
      uploadData: 'Uploaded',
      uploadTime: '{time}',
      uploadBy: 'by {by}',
      uploadByTenant: 'Company',
      comment: 'Comment',
    },
  },
  orderTask: {
    description: 'Description',
    doneOf: '{done}/{all}',
    empty: 'No tasks',
    name: 'Task',
    nameWithNumber: '{n}. Task',
    title: 'Task | Tasks',
  },
  orderTaskListTemplate: {
    name: 'Name',
  },
  project: {
    expansionPanelTitle: 'Additional information',
    internalId: 'Project number',
    name: 'Project name',
    internalIdTaken: "This project number is already used for project '{project}'.",
    singular: 'Project',
  },
  projectAlternatives: {
    addAlternative: 'Add variant',
    addAlternativeText: 'Create a variant based on your current schedule.',
    addingAlternative: 'Variant is created',
    backToPlanningMode: 'Return to planning mode',
    backToProject: 'Return to the project',
    basedOnPlanOf: 'based on the plan of {date}',
    deleteAlternativeTitle: 'Delete variant',
    deleteAlternativeBody:
      'Do you want to delete the selected variant? The variant will be removed and you will no longer be able to access it. This action cannot be undone.',
    deletedAlternativeTitle: 'Variant deleted successfully',
    deletedAlternativeBody:
      'Your variant has been deleted and can no longer be used. Since you have no more variants, the planning mode has been terminated.',
    duplicateAlternative: 'Duplicate variant',
    duplicateAlternativeBody: 'Create a variant based on an existing variant.',
    duplicatingAlternative: 'Duplicating variant',
    duplicatedAlternativeTitle: 'Successfully duplicated variant',
    duplicatedAlternativeBody: 'You can now edit both versions independently',
    editAlternativeTitle: 'Rename variant',
    editAlternativeBody: "Rename your variant or update your variant's description",
    scrollLeft: 'Scroll left',
    scrollRight: 'Scroll right',
    setupPopupTitle: 'Welcome to planning mode',
    setupPopupSubtitle:
      'Watch a short video about the planning mode, {link} or get started with your first variant right away.',
    setupPopupSubtitleLinkText: 'visit our help page',
    title: 'Planning mode',
    publishAlternativeTitle: 'Publish variant',
    publishAlternativeBody:
      'Would you like to publish your variant {name} as a new schedule and make it visible for everyone?\n\nThis variant will replace your current schedule. It will be removed from the planning mode after publishing.\n\nStatus reports, photos, documents, history entries and task statuses will be taken over from the current schedule.',
    publishAlternativeCTA: 'Publish now',
    publishingAlternative: 'Publishing variant',
    publishAlternativeDisabledTooltip: 'Open the variant to publish it.',
  },
  projectMemberships: {
    member: 'Employee',
    memberInviteNew: 'Invite',
    memberInviteNewHint: 'We need a valid email address to invite a new employee.',
    memberSelectPlaceholderText: 'Please select',
    memberSelectSearchPlaceholderText: 'Search for employee',
    projectMemberTitle: 'Project management',
    projectMembersTitle: 'Team members',
    projectMembersCreate: 'Add team members',
    projectMembersDeleteTitle: 'Remove team member',
    projectMembersDeleteMessage:
      'Do you want to remove the selected team member {member}? The member will lose access to the project.',
    projectMembersDeleted: 'Team member successfully removed',
    projectMembersDeletedBody: `The team member {member} has been removed from the project and won't be able to access it anymore.`,
    projectMembersEmpty: 'No team members found',
    projectMembersInvite: 'Invite team members',
    projectMemberInvitedAlready:
      'Already invited to the project. The invitation needs to be accepted in order to activate the access.',
    projectMembersInvitedTitle: 'Invitations sent',
    projectMembersInvitedText:
      'The team members will receive an email with all further steps. As soon as they have registered, they will be shown as <b>Active</b> in the table',
    projectMembersAddText:
      'Select existing users or invite someone new via email. Invited individuals will receive an email with further instructions.',
    projectMembersAdd: 'Add more members',
    projectMembersAdded: 'Team members successfully added',
    projectMembersSearch: 'Search for team member',
    projectMembersStatusInvitationSent: 'Invitation sent',
    projectMembersStatusActive: 'Active',
    projectMemberPermissionEdit: 'Edit permission',
    projectMemberPermissionEditted: 'Permission successfully changed',
    projectMembersTableHeaderStatus: 'Status',
    projectMembersTableHeaderName: 'Name',
    projectMembersTableHeaderPermission: 'Permission',
    projectMemberRoleEditor: 'Editor',
    projectMemberRoleReporter: 'Reporter',
    projectMemberRoleViewer: 'Viewer',
    projectMemberRoleEditorDescription: 'Has full editing access to the entire project.',
    projectMemberRoleReporterDescription:
      'Has read access to the entire project, can report progress for activities, manage files and has full access to tickets.',
    projectMemberRoleViewerDescription: 'Has read access to the entire project.',
    permissionChangeWarningTitle: 'You will lose editing access',
    permissionChangeWarningText:
      'Your change will cause you to lose full editing access for the project. This change cannot be undone by yourself.',
    invitationEmailSentAgainTitle: 'Invitation e-mail sent again',
    invitationEmailSentAgainSubtitle:
      '{email} has once again received an invitation to participate in this project.',
  },
  projectTradeSequence: {
    confirmationPopupListAction: 'Show conflicts',
    confirmationPopupListTitle: 'Following events will not be updated: ',
    confirmationPopupReasonConflict: 'events with changes that conflict with the update',
    confirmationPopupReasonOthers: 'past and finished events',
    confirmationPopupTableTitle: '{n} event with conflicts | {n} events with conflicts',
    confirmationPopupText: 'Not all events can be updated',
    confirmationPopupTitle: 'Update existing sequences?',
  },
  realTimeCollaboration: {
    technicalErrorDialogHeader: 'A technical error occurred',
    technicalErrorDialogDescription:
      'Because of a technical error, you need to reload the schedule. The page will automatically reload in {seconds} second. | Because of a technical error, you need to reload the schedule. The page will automatically reload in {seconds} seconds.',
    technicalErrorDialogSubmitAction: 'Reload',
    scheduleVersionChangeDialogHeader: 'A new version of the schedule is loading...',
    scheduleVersionChangeDialogDescription:
      '{name} is publishing a new version of the schedule. Once the new schedule has been published, you can refresh the page and continue working.',
    scheduleVersionChangeCompletedDialogHeader: 'A new schedule has been published',
    scheduleVersionChangeCompletedDialogDescription:
      '{name} has published a new version of the schedule. Reload the page to continue working. The page will automatically reload in {seconds} second. | {name} has published a new version of the schedule. Reload the page to continue working. The page will automatically reload in {seconds} seconds.',
    projectTemplateChosenTitle: 'Project setup completed',
    projectTemplateChosenDescription:
      '{name} has chosen a template for this project. Reload the page to continue working. The page will automatically reload in {seconds} second. | {name} has chosen a template for this project. Reload the page to continue working. The page will automatically reload in {seconds} seconds.',
    projectTemplateChosenOwnDescription:
      'The page will automatically reload in {seconds} second. | The page will automatically reload in {seconds} seconds.',
    scheduleVersionChangeFailedTitle: 'Something went wrong when trying to publish the version.',
    projectSetupInProgressDialogHeader: 'Project Setup',
    projectSetupInProgressDialogDescription: 'Project is currently being set up',
    projectSetupFailedTitle: 'Something went wrong when trying to set up the project.',
    noInternetConnectionMessage:
      "No internet connection. Once you're back online, you can continue working.",
    noServerConnectionMessage: 'The server is currently unreachable.',
    noWebsocketTransportMessage:
      'A setting by your company affects the application. Please contact your IT department for troubleshooting.',
    connecting: 'Connecting...',
    reconnectionCountdown:
      'Reconnecting in {seconds} second... | Reconnecting in {seconds} seconds...',
    actionFailedNotificationTitle: 'An action could not be saved',
    actionFailedNotificationDescription:
      'Due to a conflict, a change made by you could not be saved and has been reverted.',
    actionFailedNotificationAction: 'Learn more',
    projectConvertedToRealDialogHeader: 'Test project now has the status "real project"',
    projectConvertedToRealDialogDescription:
      '{userName} has changed the status of the test project {projectName} you are currently in to "real project". This means that this project can now be found in the "Real projects" section of the overview.',
    projectConvertedToRealSubmitAction: 'Understood',
    projectArchivedDialogHeader: 'Project has been archived',
    projectArchivedDialogDescription:
      '{userName} has archived the project {projectName} that you are currently in. You will be redirected to the project overview.',
    projectArchivedSubmitAction: 'To project overview',
    projectDeletedDialogHeader: 'Project has been deleted',
    projectDeletedDialogDescription:
      '{userName} has deleted the project {projectName} that you are currently in. You will be redirected to the project overview in {seconds} second. | {userName} has deleted the project {projectName} that you are currently in. You will be redirected to the project overview in {seconds} seconds.',
    projectDeletedSubmitAction: 'To project overview',
    projectAlternativeDeletedDialogHeader: 'Planning mode is ending',
    projectAlternativeDeletedDialogDescription:
      '{userName} has deleted the schedule alternative {alternativeName} that you are currently in. As a result, the planning mode will now be terminated. To continue working in another alternative, restart the planning mode.',
    projectAlternativeDeletedSubmitAction: 'Understood',
  },
  section: {
    addBottomLevel: 'Add activity row',
    addMidLevel: 'Add summary level',
    addTopLevel: 'Add phase {appendix}',
    addTopLevelRemainingHint: '({n} remaining)',
    addTopLevelMaxReachedHint: 'Maximum number of phases reached',
    collapseAllContentTooltip: 'Expand all content with | Collapse all content with',
    collapseAllOnLevelTooltip: 'Expand all on level with | Collapse all on level with',
    deleteBottomLevel: 'Delete activity row',
    deleteMidLevel: 'Delete summary level',
    deleteTopLevel: 'Delete phase',
    deleteLastRowDisabled: 'Last row can never be deleted',
    deleteWithChildrenDialogMessage:
      'Do you want to delete {section}?\nAll other contained sections and activities will be deleted as well.',
    deleteWithoutChildrenDialogMessage:
      'Do you want to delete {section}?\nAll other contained activities will be deleted as well.',
    duplicateBottomLevel: 'Duplicate activity row',
    duplicateMidLevel: 'Duplicate summary level',
    duplicateTopLevel: 'Duplicate phase {appendix}',
    indent: 'Add summary level and indent content',
    indentMaxIndentationReachedHint: 'Maximum indentation level reached',
    outdent: 'Remove summary level and outdent content',
    outdentNotificationTitle: 'Your structure has been adjusted',
    outdentNotificationText:
      'To keep a valid schedule structure, the rows <b>{rows}</b> have been automatically removed.',
    outdentNotificationAction: 'Learn more about the logic',
    placeHolderBottomLevel: 'Activity row',
    placeHolderMidLevel: 'Summary level',
    placeHolderTopLevel: 'Phase',
    reorderDifferentPhaseHint: 'Rows can only be moved within a phase level',
  },
  tenant: {
    add: 'Add company',
    address: 'Address',
    businessHours: {
      edit: 'Edit business hours',
      end: 'End',
      start: 'Start',
      title: 'Business hours',
    },
    name: 'Company name',
    openChangeDialog: 'Edit company',
    phone: 'Phone number',
    profilePicture: {
      logo: 'Logo',
      title: 'Edit company logo',
    },
    title: 'Companies',
    userEmail: 'E-mail',
    tenantInformationUpdateNotificationTitle: 'Company profile successfully updated',
  },
  tickets: {
    table: {
      creationDate: 'Creation date',
      calloutTitle: 'Filter with the search field',
      calloutText:
        'As soon as you start typing in the search field, a filter is applied to all visible fields in the table, showing you the tickets you want to see.',
      generalFilters: {
        allTickets: 'Show all tickets',
        closedTickets: 'Show closed tickets only',
        openTickets: 'Show open tickets only',
      },
      noTickets: 'Currently there are no tickets',
      noTicketResults:
        'We have searched all ticket fields... There is no ticket that contains "{query}".',
      subtitle: 'Here you can find all tickets that have been created here or in activities',
      status: 'Status',
      searchPlaceholder: 'Search and filter',
    },
    addNewTicket: 'Add new tickets',
    defaultTicketExportTitle: 'Ticket report',
    ticketCreateTitle: 'Add ticket',
    ticketDeleteTitle: 'Delete ticket',
    ticketDeleteSubtitle: 'Do you want to delete the ticket?\nThis action cannot be undone.',
    ticketEditTitle: 'Edit ticket',
    ticketExportTitle: 'Export file is created',
    ticketExportSubtitle: 'Your export contains all tickets of your current view.',
    ticketViewTitle: 'Inspect ticket',
    ticketViewInfo: 'Ticket created on {date} by {creator}',
    ticketFormGeneralLabel: 'General information',
    ticketFormAssignmentLabel: 'Assignment',
    ticketFormAssignmentGroupEmailHint: 'The members of {group} will be notified via mail',
    ticketFormAssignmentOwnEmailHint:
      "You won't receive a mail notification if you assign yourself",
    ticketFormAssignmentPersonEmailHint: '{person} will be notified via mail',
    ticketFormDeadlineLabel: 'Completion',
    ticketFormDeadlinePlaceholder: 'Deadline',
    ticketFormNotificationCreateTitle: 'Ticket created',
    ticketFormNotificationReopenedTitle: 'Ticket reopened',
    ticketFormNotificationUpdatedAssignmentTitle: 'Ticket updated',
    ticketFormNotificationText:
      'The responsible parties have been notified about the ticket via mail',
    ticketNoOrderAssigned: 'Not assigned to an activity',
    ticketStatusReportDone: 'Report done',
    ticketStatusRemoveReportedDone: 'Remove completed report',
    ticketStatusAcceptReportedDone: 'Confirm completed report',
    ticketStatusRemoveDone: 'Report open',
    noTicketsAdded: 'No tickets added',
  },
  user: {
    external: '{n} external',
    firstName: 'First name',
    formSections: {
      contactInfo: 'Contact',
      profileInfo: 'Profile',
      settings: 'Settings',
    },
    internal: '{n} internal',
    language: 'Language',
    lastName: 'Last name',
    name: 'Name',
    password: 'Password',
    passwordRequirements: {
      header: 'Password must contain:',
      number: 'number',
      letter: 'letter (upper- & lowercase)',
      specialCharacter: 'special character',
      length: '{n} characters',
    },
    timezone: 'Time zone',
    title: 'User',
    signInMethod: 'Sign in method',
    microsoftSSO: 'Microsoft SSO',
    microsoftSSOActivated: 'Activated',
    microsoftSSODeactivated: 'Not activated',
    microsoftSSOActivationAction: 'Activate now',
    ownUserAlias: 'You',
  },
  orderHistory: {
    titles: {
      orderCreated: 'Activity created',
      orderUpdated: 'Activity modified',
      newStatus: 'New status',
      tasksCreated: '{n} task created | {n} tasks created',
      tasksUpdated: '{n} task modified | {n} tasks modified',
      tasksDeleted: '{n} task deleted | {n} tasks deleted',
      tasksCompleted: '{n} task completed | {n} tasks completed',
      tasksReopened: '{n} task reopened | {n} tasks reopened',
      photosCreated: '{n} photo added | {n} photos added',
      photosDeleted: '{n} photo removed | {n} photos removed',
      documentsCreated: '{n} document added | {n} documents added',
      documentsDeleted: '{n} document removed | {n} documents removed',
      linksCreated: '{n} link added | {n} links added',
      linksUpdated: '{n} link modified | {n} links modified',
      linksDeleted: '{n} link removed | {n} links removed',
      unknown: '?',
    },
    orderChange: {
      generalSubtitle: 'General',
      tasksSubtitle: 'Tasks',
      entityDeleted: 'Deleted',
      fields: {
        name: 'Name',
        timePeriod: 'Time period',
        wbsSection: 'Assignment',
        subcontractor: 'Contractor',
        estimatedWorkers: 'Workers',
        calendar: 'Schedule',
        trade: 'Trade',
        isFixed: 'Activity fixed',
        dryingBreakAdded: 'Drying time added',
        dryingBreakUpdated: 'Drying time modified',
        dryingBreakDeleted: 'Drying time removed',
        dryingBreakName: 'Name',
        dryingBreakDuration: 'Duration',
        contributorGroup: 'Team or Company',
      },
    },
    tasks: {
      changed: 'Modified',
      created: 'Added',
      deleted: 'Deleted',
    },
  },
  scheduleEntities: {
    end: 'To',
    start: 'From',
  },
  projectStructureTemplates: {
    editTitle: 'Edit template',
    copyTitle: 'Edit template',
    createTitle: 'Create structure template',
    nameInputLabel: 'Template name',
    nameInputPlaceholder: 'Name...',
    nameNotUniqueHint: 'This name is already used for another template',
    descriptionInputPlaceholder: 'Add a short description..',
    baseSelectionTitle: 'Choose base',
    baseSelectionSubtitle:
      'Select a default structure of koppla or one your existing projects as base and modify it in the next step to create your template.',
    baseSelectionSidebarTitle: 'View projects',
    baseSelectionSidebarSubtitle: 'Select a base to see a preview of the structure.',
    copySuffix: '- Copy',
    deleteConfirmationTitle: 'Delete structure template',
    deleteConfirmationMessage:
      "Do you really want to delete the selected structure template '{name}'?",
    createNotificationTitle: 'Structure template successfully created',
    updateNotificationTitle: 'Structure template successfully updated',
    deleteNotificationTitle: 'Structure template successfully deleted',
    searchBarPlaceholder: 'Search projects',
    structureSelectionTitle: 'Choose template',
    structureSelectionSupportText: 'All about templates',
    structureSelectionSidebarTitle: 'Available structure templates',
    structureSelectionSidebarSubtitle: 'Select a template to see its preview.',
    structureSelectionEmptyTemplatesTitle: 'No templates created yet',
    structureSelectionEmptyTemplatesSubtitle:
      'Your company has not yet created its own structure templates. Just continue with the koppla template!',
    kopplaTemplates: 'koppla-templates',
    tenantTemplates: 'Company templates',
    projects: 'Projects',
    kopplaTemplateSubtitle1: 'Created with 🖤 by koppla',
    kopplaTemplateSubtitle2: 'For all phases',
    noProjectStructureTemplatesTitle: 'No structure templates available',
    noProjectStructureTemplatesHint:
      'You can create templates for the structure of projects and then use them company-wide in every project',
    helpPageLinkText: 'Visit our help page for more information',
    featureTeaserPlaceHolderFirstTitle: 'Building in existing structures with tendering',
    featureTeaserPlaceHolderFirstSubtitle:
      'Planning of tendering and structure for existing buildings',
    featureTeaserPlaceHolderSecondTitle: 'Planning and execution',
    featureTeaserPlaceHolderSecondSubtitle:
      'Planning of tendering and structure for construction planning and execution',
  },
};
